import React from 'react';
import styles from './UserMessage.module.css';
import type { ChatMessage } from '../../types/foreman';

interface UserMessageProps {
  message: ChatMessage;
}

function formatTime(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

const UserMessage: React.FC<UserMessageProps> = ({ message }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.bubble}>
        <div className={styles.content}>{message.content}</div>
        <div className={styles.footer}>
          <span className={styles.sender}>{message.sender}</span>
          <span className={styles.timestamp}>{formatTime(message.timestamp)}</span>
        </div>
      </div>
    </div>
  );
};

export default UserMessage;
